const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'] as const;
const STORAGE_KEY = 'equiphoto_utm';

/**
 * Capture UTM params from URL and store in sessionStorage.
 * Call once on app mount.
 */
export function captureUtmParams(): void {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm: Record<string, string> = {};
    let hasUtm = false;

    for (const key of UTM_KEYS) {
      const value = params.get(key);
      if (value) {
        utm[key] = value;
        hasUtm = true;
      }
    }

    if (hasUtm) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
    }
  } catch {
    // sessionStorage may be unavailable in some contexts
  }
}

/**
 * Get stored UTM params for checkout.
 */
export function getUtmParams(): Record<string, string> {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}
